<template>
    <StatusAlert v-show="showModalSuccess" status="success">
        <template #body>
            <h3>{{ $t("tickets.newTicket.modal.success.openTitle")}}</h3>
            <p>{{ $t("tickets.newTicket.modal.success.yourRequest")}}</p>
        </template>
       <template #footer>
            <button class="cdlButtonSingle green" v-on:click="closeModal()">
                {{ $t("tickets.newTicket.modal.close") }}
            </button>
        </template>
    </StatusAlert>

    <StatusAlert v-show="showModalError" status="error">
        <template #body>
            <h3>{{ $t("tickets.newTicket.modal.error.openTitle")}}</h3>
            <p>{{ $t("tickets.newTicket.modal.error.yourRequest")}}</p>
        </template>
       <template #footer>
            <button class="cdlButtonSingle green" v-on:click="closeModal()">
                {{ $t("tickets.newTicket.modal.close") }}
            </button>
        </template>
    </StatusAlert>

    <div id="incidentForm">
        
        <div class="contentFormTwoCol">
            <div class="contentPrimary">
                <div style="display: flex; align-items: baseline;">
                    <div class="img-container">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAABvNJREFUaEPFWg1MU1cU7nv9sbQFBiJVWlpLqYCA0wlIhBmJOnUmgjoFE92IusyF7MfE6dxY1IzN6ZY4t5C5RA2bJqLO38QpU4NRMag4jYD8lB8pLVpgMqAtpT+vu/fJY8/a9r1bCryElPaee8733XPOveeeFuME8Ons7JT0O/EEzEkoXRzXJIzDEUH1Lg7HgnGwLhcXbwvmEnWRkZGmQJkFNkb2NOs6Urg83mIM58zjuLBkVtowV7WL4NxwOhxlakVUFas5XoT8JtDSblyH4dh6HGcJ2gsAgoBkXEdjoqXH/CGCTKC1w5iDY/gWYEzjj0Efc7SEi9ivipKeQ9HLmkCdXj9RiPO/AeCXoxhAlQUkLlgJ+5cJcvk/bOayItDQ1pE5gcf7EYRMFBulI5UBIdUx6HB8GqeMusWki5FAq6E7G8ddvzApGo1xgsA+VMkizvvS7ZPAeIKnQDOR8EoAho1QwD85GiuLqtNqs6/xFk4eCVQ1NERESMIuj1XMMxGCOdFt6lmSEhfX7S7rkQDYKg+O9m7DBNp9HO5OYIvdzEigqb1jBZ/HL0Y1MBbydoe9IDY66izdlrsHsBaD8QYXx9WBANTTb+FCPWHBImcg9DkJojlGJp0HdIHy6sXzEgFtW8d6gYC/119jEPCdap24sb1b2Ge2kuCpZ1KYxK6Uvmabk6wwj4SQzWbfrlFGHfVEAGvRG8u4XDzJHwLl97TBFdVtEjZzM15X9WfNVvtVkTqdRE2MXLqY8sKwBxqadalCUZDPQ8MTOKvVjv926X54V4+JzwY8JRMtDbXlLpjZIxTyCZR5UNZqGciOUyvu0UMI07YZvhIIBK9kOZPyX89WRqCCp5N4b1kqq5qHjsNmsx3UKGVfQy9QHsCa9U+v8Li86UyA6eMoYeNNb0ay0pSVqulHsetwOh6r5VMWDROorKwMmaJU16MogQlbfOp2pK85hRsWPoXjRUeuTvElV7B6bidqYj9ta45PT0/vIz1Q29o+RyIUvrS/MpG5dLs+5H69XhwIArPj5ealc+P7mGzSx01W64pEVfQdSAB73KRbIxYH7UdRcODEzch+8+BLWyXKfLos3GI/WJH+SpngS5/ZPLBleqziJEmgrqW9QBQk/AIFAFNYoOiCslS4sZ1nGbB+mxATXfzCA81t28Qi0SdsJ7OJf6hr4/I0clUPX7gbwaQbNQ/MFsuB6WrlPpJArbZ1u0Qi+ZjJCDXOlgDbJIZ6UQmYTKafEjWqvSSB6sbWj0KCJZ+zJQDl2IQQCgHUEOrrN32XPE31M0ngQW3j2vDwsB9QCLBJYrYE/Eni5897ts5KnHacJHCz6mGGQiZDun2N9zaqMxjWvJkys4IkcOjQobBFy7JrUDzAJg/YJLGAz3O9n5PWhXqQXbl4PmnTpk09VCnBa2o3lPF5ggQUEuNVStgdtrrYaBmsSB0UAfxRfdPu0NDQjSgEoGzJxXsT9cZeAeo8KC8HFWm+H8Vcb2/v4RnxsTuBCmK4mLt6/VamJi7uBCoQWE6XXnsYhkoCgs/zs5zWNjTkLpyfCZte/1ej4I1A+8Twp2ACWhhRhNmGE4z51HiZGbUCpezYBm11mqmyt8F7G50AHOfefVCzQTpZuhvVC/QDrhJcKXXGfwXudwS4VSrAlTJ9hFdK4zPjzrRZSUeATfKeTb8Tw/+DQFfiCuhKqPwlQZ8X6Es96Eq0gq4EvAcMwNV3J0B64XbVg1yZTI50qAWCLBsdBoN+69yUWTBPh7scr7RVwKCwrvlJsUgkXsJG6VjJWCzmywnqqQXAnpVafU8eIL2wa8+e6HfX5Z8BXx1NHiuAvuyAr6Ke/X6sZOWuHTva6avvjQD8nH/xavmCpEQyWcb9qamt2bBsYdY1AMTuDsZbdxp+PqG84u47MTGqfePJoKWldVtWRtofAMMgPXQoTL6+H8CHSKwaLxJD4E8PgffYP2L6hoYkce7SX1kzkpKLxionYMw/qqkuzFn6Vrkv8L5ygB41kITgs8JCWX7+xkKJWAKLqFF7TGZTWUnJ4aLvi4oMwAg8bX127pg8QA81HngTdL2iMluuUGwO1GFHGYCHlF6nOzg/Ix22N+FB5fAU82yT2NsKwzYKrDyFt+78nSuVSlf7WztRBmBtYzQaT2XOeQMeUHCPh6vOuh3P1gN0QnAOmRvw78Tpc7OnxSdkBYdI0tneJ2A9399nqmysryvPXZVzfyjO4S4Dw2W4988mTv0hQA8rSASGFvQKLy8vL3Tl2vWayIhJcpFYHA5+hkD+2AP8nAAcpObnnd1d+jPHj2pLS0t7h0IErjYMFWTgdBBsiPqSGb5TDHkGkoKhBl+pMbiqECQMDfhKB4y04u5ARuIBb6SYdI4IsLvR/wBVDcJXWwfBBgAAAABJRU5ErkJggg==" alt="icon" width="45">
                    </div>
                    <div class="text-container" style="flex-grow: 1; padding-left: 15px;">
                        <p class="text">{{ $t("help.managedService.incident.title") }}</p>
                    </div>
                </div>
                 <hr>
                <div class="text-container">
                    <p class="label">{{ $t("help.managedService.incident.solution") }}</p>
                </div>
            </div>
            <div class="contentSecondary">
                <div class="mdl-grid padding0">
                    <div class="mdl-cell mdl-cell--12-col">
                        <h2 class="title">{{ $t("help.managedService.incident.primarySectionTtile") }}</h2>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col">
                        <span class="labelTwo">{{ $t("help.managedService.incident.primaryInfo") }}</span>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col">
                        <div class="content-hub" style="opacity: 1;">
                                <form id="managed-service-incident" @submit.prevent="handleSubmit" class="form"  enctype="multipart/form-data" style="display:flex; flex-direction:column; gap:20px;" data-valid="false">
                                    <div>
                                        <label class="label" for="subject">{{$t("help.managedService.incident.form.label.name")}}*</label>
                                        <div class="cdl-input">
                                            <input type="text" id="subject" name="subject" class="content-input"  v-model="form.subject">
                                        </div>
                                        <label v-if="errors.subject!=''" class="error" for="subject" id="error-subject">{{ errors.subject }}</label>
                                    </div>
                                    <div>
                                        <label class="label" for="body">{{$t("help.managedService.incident.form.label.description")}}*</label>
                                        <div class="cdl-textarea">
                                            <textarea  id="body" name="body" class="content-input" v-model="form.body"></textarea>
                                        </div>
                                        <label v-if="errors.body!=''" class="error" for="body" id="error-body">{{ errors.body }}</label>
                                    </div>
                                    <div>
                                        <label class="label" for="urgency">{{$t("help.managedService.incident.form.label.serveritylevel")}}*</label>
                                        <select id="urgency" name="urgency" class="cdl-select" v-model="form.urgency">
                                            <option value="">{{$t("help.managedService.incident.form.serveritylevel.options.default")}}</option>
                                            <option value="l1">{{$t("help.managedService.incident.form.serveritylevel.options.low")}}</option>
                                            <option value="l2">{{$t("help.managedService.incident.form.serveritylevel.options.medium")}}</option>
                                            <option value="l3">{{$t("help.managedService.incident.form.serveritylevel.options.high")}}</option>
                                        </select>
                                        <label v-if="errors.urgency!=''" class="error" for="urgency" id="error-urgency">{{ errors.urgency }}</label>
                                    </div>
                                    <div>
                                        <label class="label" for="referent">{{$t("help.managedService.incident.form.label.email")}}*</label>
                                        <div class="cdl-input">
                                            <input type="text" id="referent" name="referent" class="content-input" v-model="form.referent">
                                        </div>
                                        <label v-if="errors.referent!=''" class="error" for="referent" id="error-referent">{{ errors.referent }}</label>
                                    </div>
                                     <div>
                                    <label style="margin-right:10px;">{{$t("help.managedService.incident.form.label.attachments")}}  </label>
                                    
                                    <input type="file" id="attachments" ref="fileInput"  multiple name="attachments" @change="handleFileChange" />
                                    <p>{{$t("help.managedService.incident.form.label.maxFileSize")}} </p>
                                    <label v-if="errors.attachments!=''" class="error" for="attacments" id="error-attachments">{{ errors.attachments }}</label>

                                    </div>   

                                      <div class="cdlContentButtonSingle">
                                        <button type="submit"
                                                class="cdlButtonSingle green"
                                            >
                                            {{ $t("help.submitLabel") }}
                                        </button>
                                    </div>
                            </form>
                        </div>
                    </div>
                 </div><hr>
            </div>
        </div>
    </div>
</template>



<script setup>
    import { useI18n } from "vue-i18n";
    import { reactive, computed, ref} from "vue"
    import axios from "axios"
    import StatusAlert from '@/components/Primitives/Alerts/StatusAlert.vue'
    import { useUserStore } from "@/stores/UserStore";

    const fileInput = ref(null)
    const {t} =useI18n()
  
    const form = reactive({
        subject: "",
        body: "",
        urgency: "",
        referent: ""
    })

    const errors = reactive({
        subject: "",
        body: "",
        urgency: "",
        referent: ""
    })
    const MAX_FILE_SIZE = 5 * 1024 * 1024


    const showModalSuccess=ref(false)
    const showModalError=ref(false)

    function closeModal(){
        showModalSuccess.value=false
        showModalError.value=false
    }

    function validate() {
        let isValid = true
            
        // reset errori
        Object.keys(errors).forEach(k => errors[k] = "")

        if (!form.subject) {
            errors.subject = t("help.managedService.incident.form.validationError.required")
            isValid = false
        }

        if (!form.body) {
            errors.body = t("help.managedService.incident.form.validationError.required")
            isValid = false
        }
        if (!form.urgency) {
            errors.urgency = t("help.managedService.incident.form.validationError.required")
            isValid = false
        }
         
        if (form.attachments?.length) {
            form.attachments.forEach(file => {
                
                if (file.size > MAX_FILE_SIZE) {
                    console.log("filesize", file)
                    errors.attachments = t("help.managedService.incident.form.validationError.fileSize")
                    isValid= false
                }
            })
        }
        if (!form.referent) {
            errors.referent = t("help.managedService.incident.form.validationError.required")
            isValid = false
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(form.referent)) {
                errors.referent = t("help.managedService.incident.form.validationError.validEmail")
                isValid = false
            }
        }
        
        return isValid
    }

    function emptyForm(){
        form.subject=""
        form.body=""
        form.urgency=""
        form.referent=""
        form.attachments=null
        form.attachments = []

        if (fileInput.value) {
            fileInput.value.value = null
        }
    }

    function handleFileChange(event) {
        form.attachments = Array.from(event.target.files)
    }
    async function handleSubmit() {
        
        if (!validate()) return

        try {
         
            const formData = new FormData()

            // campi normali
            formData.append("subject", form.subject)
            formData.append("body", form.body)
            formData.append("urgency", form.urgency)
            formData.append("referent", form.referent)

            // upload
           if (form.attachments?.length) {
                form.attachments.forEach(file => {
                    formData.append("attachments", file)
                })
            }

            for (let pair of formData.entries()) {
                console.log(pair[0], pair[1])
            }
            
         

            const userStore = useUserStore();
            const tokenKc = computed(() => userStore.token);

            let he = {
                Accept: "application/json",
                Authorization: "Bearer " + tokenKc.value,
            };
            try {
                await axios.post(
                    window.VUE_APP_MISTRA_URL + "tickets/v2/ticket/tmp",
                    formData,
                    { headers: he }
                )

                showModalSuccess.value = true
                emptyForm()

                setTimeout(() => showModalSuccess.value = false, 5000)

                } catch (err) {
                console.error(err)
            }
            
        } catch (e) {
            showModalError.value=true
            emptyForm();
            console.error(e)
        }
    }
</script>

<style scoped>
   input.error,
    textarea.error,
    select.error {
        
        border: 1px solid red;
    }
    label.label{
       padding:0px; 
       margin:0px;

    }
    .cdl-input, .cdl-textarea, .cdl-select{
        margin-top:10px;
    }
    label.error{
        padding:0px; padding-top:10px;margin:0px!important;
    }
</style>